
import Schema from "async-validator";

// 数字类型验证
const NumberValidation = (value) => {
  return (value !== "" && parseFloat(value) !== "NaN" && !isNaN(value) && !isNaN(parseFloat(value)));
};



export default {
  async validate(source, rules) {
    var validator = new Schema(rules);

    var errors;

    await validator
      .validate(source)
      .then(() => { })
      .catch((errs) => {
        errors = errs.errors;
      });

    return errors || [];
  },
  async validates(sources, rules) {
    var validator = new Schema(rules);

    var errors;

    await validator
      .validate(sources)
      .then(() => { })
      .catch((errs) => {
        errors = errs.errors;
      });

    return errors || [];
  },
  isError(item, field) {
    item = item || []
    return item.filter(t => t.field === field).length > 0
  },
  NumberValidate(value) {
    return NumberValidation(value)
  }
}
